







































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import ActivitySection from "../common/ActivitySection.vue";
import getUrlParam from '@/common/utils/getUrlParam';
import fetch from "@/common/api/fetch";
import desensitizeName from '@/common/utils/desensitizeName';
import { AxiosPromiseData,AxiosPromiseError} from "@/common/interface";
@Component({
  components: {
    "activity-section": ActivitySection
  }
})
export default class GachaToastModal extends Vue {
  @Prop() showToast!: boolean; 
  @Prop() gachaToastData!: any;
  @Getter("gachaTypeParameter") gachaTypeParameter!: any;
  @Getter("mainTextColor") mainTextColor!: string;
  @Getter("section") section!: object;
  @Getter("urlUid") urlUid!: string;
  @Getter("posterName") posterName!: string;
  @Action("changeRankList") changeRankList!: Function;
  @Action("changeUserAwardInfo") changeUserAwardInfo!: Function;
  @Action("changePosterName") changePosterName!: Function;
  @Action("changePosterAvatar") changePosterAvatar!: Function;
  @Action("changeGachaParameter") changeGachaParameter!: Function;
  @Action("changeSelectBGM") changeSelectBGM!: Function;
  @Action("changeGachaStart") changeGachaStart!: Function;
  @Getter('openId') openId!: string;
  @Getter("uid") uid!: string;
  getUrlParam: Function = getUrlParam;
  
  desensitizeName:Function = desensitizeName;
  // 显示/隐藏分享popup
  handleRedirectToSharePage() {
    // 跳转到小程序分享页面
    const broadcastId = getUrlParam('broadcastId');
    const posterName = this.posterName;
    const origin = getUrlParam('origin');
    // 如果是从独立版小麦秀小程序进入的分享页,那么分享的时候就跳到独立版小麦秀的分享页
    if (origin === 'ordinary') {
      window.wx.miniProgram.redirectTo({
        url: `/pages/activity/activityShare/main?id=${broadcastId}&parentUid=${this.urlUid}`
      });
    } else {
      window.wx.miniProgram.redirectTo({
        url: `/pages/user-share/index?broadcastId=${broadcastId}&parentUid=${this.urlUid}&name=${posterName}`
      });
    }
  }
  handleCloseModal() {
    if(this.uid===this.urlUid){
      this.getViewDetail();
    }else{
      this.getGachaLeaderDetail(this.urlUid);
    }
    if(this.gachaTypeParameter.gachaType==='prize' && this.gachaToastData.code==='PRIZE_GAIN'){
      const prizeList = this.gachaToastData.data.prizeList;
      const prize = Object.assign(this.gachaTypeParameter.prize,{'proList':prizeList});
      this.changeGachaParameter({'prize':prize});
    }
    this.getRankList();
    const payload = {
      selectedBGM:{
        url:'https://image.xiaomaiketang.com/xm/YkiWbG4ydT.mp3',
        loop:true
      }
    };
    this.changeSelectBGM(payload);
    this.changeGachaStart(false);
    this.$emit("hide");
  }
  getRankList() {
    const param = {
      activityId: getUrlParam("broadcastId"),
    };
    fetch.newpost('anon/gacha/getRankList', param)
    .then((res: AxiosPromiseData) => {
      this.changeRankList(res.result);
    });
  }
  getViewDetail(){
      const openId = this.openId;
      fetch.newpost('anon/gacha/getViewerDetail', {
        openId,
        activityId: getUrlParam('broadcastId'),
      }).then((res: AxiosPromiseData) => {
        const { result } = res;
        const userAwardInfo = result;
        this.changeUserAwardInfo(userAwardInfo);
      }).catch((e: AxiosPromiseError) => {
        throw new Error(e.message);
      });
  }
  getGachaLeaderDetail(userId: string | undefined) {
    fetch.newpost('anon/gacha/getLeaderDetail', {
      userId,
      activityId: getUrlParam('broadcastId'),
    }).then((res: AxiosPromiseData) => {
      const { result } = res;
      const { xmShowSignInVO } = result;
      const {
        avatar,
        name,
      } = result;
      const userAwardInfo = result;
      this.changeUserAwardInfo(userAwardInfo);
      
    }).catch((e: AxiosPromiseError) => {
      throw new Error(e.message);
    });
  }
}
